import styled, { keyframes } from 'styled-components';

import * as Common from '../../Styles';

const Theme = Common.Theme;

const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const SpinnerOverlay = styled.div`
	width: ${(props) => (props.width ? props.width : '100%')};
	height: ${(props) => (props.height ? props.height : '100%')};
	position: absolute;
	background: ${Theme.backdrop};
	z-index: 10000;
	display: none;
`;

export const SpinnerCircle = styled.div`
	position: relative;
	top: 50%;
	left: 50%;
	margin-left: ${(props) => (props.width ? `calc(-${props.width}/2)` : '-75px')};
	margin-top: ${(props) => (props.height ? `calc(-${props.height}/2)` : '-75px')};
	width: ${(props) => (props.width ? props.width : '150px')};
	height: ${(props) => (props.height ? props.height : '150px')};
	border-radius: 50%;
	background: linear-gradient(45deg, transparent, transparent 40%, ${Theme.primary});
	animation: ${rotate} 2s linear infinite;

	&:before {
		content: '';
		position: absolute;
		top: 6px;
		left: 6px;
		right: 6px;
		bottom: 6px;
		background: ${Theme.backdrop};
		border-radius: 50%;
		z-index: 10000;
	}

	&:after {
		content: '';
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		background: linear-gradient(45deg, transparent, transparent 40%, ${Theme.primary});
		border-radius: 50%;
		z-index: 1;
		filter: blur(30px);
	}
`;
